import React, { useRef, useState, useEffect } from "react";
import {
  I2cInput,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox, I2cRadioGroup, I2cRadioButton, I2cRadio, I2cFileUpload, I2cAlert, I2cTooltip, I2cIcon
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardServiceOption } from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { useMutation } from "react-query";
import FilesUploadService from "../../../Services/FilesUploadService";

const RewardsPromotionsAndDisputeForms = ({ type,control, handleValueChanges, methods, errors, appSelectionForProgram, fileJson,setFormValidStates }) => {
  const Manual = useRef(null);
 
  const handleCheckboxChange = (event, fieldName) => {
    const SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues(fieldName) ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue(fieldName, updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };
  const formData = new FormData();
  useEffect(() => {

    customElements.whenDefined('i2c-file-upload').then(() => {
      if (Manual.current !== null) {
        const myDropzone = Manual.current.getDropZone();
        const token = localStorage.getItem("token");
        myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
        myDropzone.options.headers = {
          'X-Requested-With': null,
          'Access-Control-Allow-Headers': null, 'Authorization': 'Bearer ' + token,
        };
      }
    });

  }, [])
  const handleFileUpload = async (name) => {
    try {
      formData.append("file", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
      methods.trigger();
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (formData) => {
      // setFormValidStates("5_0", false);
      return await FilesUploadService.uploadFile(formData);
    },
    onSuccess: (data) => {
      methods.setValue("card_management_feature_dispute_form_custom_form_file", data?.data?.url);
      methods.trigger();

      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  return (
    <>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Rewards and Cashback
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_rewards_and_cashback_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable this feature on the application."
                  {...field}
                  name="card_management_feature_rewards_and_cashback_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_rewards_and_cashback_feature_app_enable_custom","")
                      methods.setValue("card_management_feature_rewards_and_cashback_feature_required_for",[])
                      methods.setValue("card_management_feature_rewards_and_cashback_rewards_type","")
                      methods.setValue("card_management_feature_rewards_and_cashback_manual_redeem","")
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_rewards_and_cashback_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_rewards_and_cashback_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_rewards_and_cashback_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_rewards_and_cashback_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_rewards_and_cashback_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_rewards_and_cashback_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_rewards_and_cashback_feature_app_enable_custom"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_rewards_and_cashback_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_rewards_and_cashback_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_rewards_and_cashback_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_rewards_and_cashback_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_rewards_and_cashback_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_rewards_and_cashback_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_rewards_and_cashback_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_rewards_and_cashback_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Specify the type of Rewards below.
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_rewards_and_cashback_rewards_type"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        onI2cChange={(e) => {
                          methods.setValue("card_management_feature_rewards_and_cashback_rewards_type", e.target.value);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {["Points Based Rewards", "Cashback Rewards"].map((cpi, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={cpi}
                              sublabel=""
                              value=""
                              checked={methods.watch("card_management_feature_rewards_and_cashback_rewards_type") === cpi}
                              type="checkbox"
                            >
                              <I2cRadio
                                slot="prefix"
                                name="credit_programType"
                                value={cpi}
                                filled
                                label=""
                                checked={
                                  methods.watch("card_management_feature_rewards_and_cashback_rewards_type") === cpi
                                }
                              />
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_rewards_and_cashback_manual_redeem"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        label="Please confirm if you would like to enable the feature of allowing accountholders to manually redeem all rewards."
                        {...field}
                        name="card_management_feature_rewards_and_cashback_manual_redeem"
                        onI2cChange={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        {["Yes", "No"].map((bc, index) => (
                          <I2cRadioButton
                            key={index}
                            checked={
                              methods.watch("card_management_feature_rewards_and_cashback_manual_redeem") === bc
                            }
                            value={bc}
                          >
                            {bc}
                          </I2cRadioButton>
                        ))}
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.card_management_feature_rewards_and_cashback_manual_redeem &&
                        methods.formState.touchedFields.card_management_feature_rewards_and_cashback_manual_redeem
                        ? true
                        : false
                    }
                    message={errors.card_management_feature_rewards_and_cashback_manual_redeem?.message ?? "Invalid input"}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Credit Promotions
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_credit_promotions_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable this feature on the application."
                  {...field}
                  name="card_management_feature_credit_promotions_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_credit_promotions_feature_app_enable_custom","")
                      methods.setValue("card_management_feature_credit_promotions_feature_required_for",[]) 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_credit_promotions_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_credit_promotions_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_credit_promotions_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_credit_promotions_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_credit_promotions_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_credit_promotions_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_credit_promotions_feature_app_enable_custom"}
                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_credit_promotions_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_credit_promotions_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_credit_promotions_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_credit_promotions_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_credit_promotions_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_credit_promotions_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_credit_promotions_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_credit_promotions_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <span slot="label" className="organize-tooltip">
            <div className="sub-heading">Dispute Form</div>
            <I2cTooltip
              content="Dispute Form enables cardholders to file dispute for any card account related service. 
              Clients can either choose to use i2c standard dispute form or they can use a customized dispute form. "
              placement="right-start"
            >
              <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
            </I2cTooltip>
          </span>

        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_dispute_form_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable this feature on the application."
                  {...field}
                  name="card_management_feature_dispute_form_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_dispute_form_feature_required_for",[])
                      methods.setValue("card_management_feature_dispute_form_dispute_options",[]) 
                      methods.setValue("card_management_feature_dispute_form_feature_app_enable_custom","") 
                      methods.setValue("card_management_feature_dispute_form_custom_form_file","") 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_dispute_form_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_dispute_form_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_dispute_form_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_dispute_form_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_dispute_form_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_dispute_form_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_dispute_form_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_dispute_form_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_dispute_form_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_dispute_form_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_dispute_form_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_dispute_form_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_dispute_form_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Select the following:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_dispute_form_dispute_options"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["Enable Dispute Form", "Enable Dispute Center"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_dispute_form_dispute_options")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_dispute_form_dispute_options");
                                }}>
                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_dispute_form_dispute_options"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_dispute_form_dispute_options")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_dispute_form_dispute_options &&
                              methods.formState.touchedFields.card_management_feature_dispute_form_dispute_options
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_dispute_form_dispute_options?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_dispute_form_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_dispute_form_feature_app_enable_custom"}
                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12 8@md">
                <div className="custom-label-light mb-1-5">
                  Upload customized dispute form
                </div>
                <Controller
                  name="card_management_feature_dispute_form_custom_form_file"
                  control={control}
                  render={({ field }) => (
                    <I2cFileUpload
                      ref={Manual}
                      // max-file-size="0.439453125"
                      autoProcessQueue={false}
                      no-mobile-controls
                      max-files={1}
                      className="customFileUpload"
                      setAcceptedFiles=".pdf, .docs"
                      icon="linear-document-upload"
                      label="Click to upload"
                      caption="or drag and drop"
                      name="card_management_feature_dispute_form_custom_form_file"
                      message="Format: PDF or Doc"

                      onI2cFileRemoved={(e) => {
                        if (
                          fileJson?.card_management_feature_dispute_form_custom_form_file?.length
                        )
                          methods.setValue(
                            "card_management_feature_dispute_form_custom_form_file",
                            fileJson?.card_management_feature_dispute_form_custom_form_file,
                          );
                        else methods.setValue("card_management_feature_dispute_form_custom_form_file", "");
                        methods.trigger();
                        handleValueChanges();
                      }}
                      onI2cAddedFile={(e) => {
                        console.log("Manual.current.getDropZone().files cmf",Manual.current.getDropZone().files)
                        handleFileUpload(
                          Manual.current.getDropZone().files[
                          Manual.current.getDropZone().files.length - 1
                          ],
                        );
                      }}
                    />
                  )}
                />
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Dispute Center
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <I2cAlert
            open
            type="plain"
            variant="neutral"
            headerArt="cs-linear-info"
            layout="layoutAsideLeft" >
            <span slot="label">The platform used by the Dispute Center may have an associated pricing.</span>
          </I2cAlert>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_dispute_center_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable it on the application."
                  {...field}
                  name="card_management_feature_dispute_center_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_dispute_center_feature_required_for",[]) 
                      methods.setValue("card_management_feature_dispute_center_feature_app_enable_custom","")  
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_dispute_center_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_dispute_center_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_dispute_center_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_dispute_center_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_dispute_center_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_dispute_center_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_dispute_center_feature_app_enable_custom"}
                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_dispute_center_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_dispute_center_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_dispute_center_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_dispute_center_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_dispute_center_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_dispute_center_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_dispute_center_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_dispute_center_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>

            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Account Notifications
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <I2cAlert
            open
            type="plain"
            variant="neutral"
            headerArt="cs-linear-info"
            layout="layoutAsideLeft" >
            <span slot="label">Please contact your i2c Account Manager to provide you the Alerts CSD.</span>
          </I2cAlert>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_account_notification_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable cardholder alerts."
                  {...field}
                  name="card_management_feature_account_notification_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_account_notification_feature_required_for",[]) 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_account_notification_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_account_notification_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_account_notification_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_account_notification_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_account_notification_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_account_notification_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_account_notification_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_account_notification_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_account_notification_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_account_notification_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_account_notification_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_account_notification_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_account_notification_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>
    </>
  );
};

export default RewardsPromotionsAndDisputeForms;
